import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'

export default function WhatsappButton() {
    return (
        <a href='https://wa.me/+918347763858?text=Hello KVH FURNISHING,  %0a %0a Can i get some more information about curtain fabrics.' target='_blank'>
            <div className='whatsapp'>
                <div>
                    <FaWhatsapp className='what-icon' />
                </div>
            </div>
        </a>

    )
}
